import React from 'react';

import { getDayString } from '~libs/dayjs';

export interface BaseAppointmentProps {
  date: string | Date | null;
  start_time: string;
  client?: {
    full_name: string;
  };
  layout?: 'client-first' | 'date-first';
  className?: string;
}

const BaseAppointment: React.FC<BaseAppointmentProps> = ({
  date,
  start_time,
  client,
  layout = 'date-first',
  className = '',
}) => {
  const dateTimeInfo = (
    <div>
      {getDayString(date)} {start_time}
    </div>
  );

  const clientInfo = <div>{client?.full_name}</div>;

  return (
    <div className={className}>
      {layout === 'date-first' ? (
        <>
          {dateTimeInfo}
          {clientInfo}
        </>
      ) : (
        <>
          {clientInfo}
          {dateTimeInfo}
        </>
      )}
    </div>
  );
};

export default BaseAppointment;
